module.exports = __webpack_public_path__ + "static/jolina-39a831a52eb9777a5e1508ca7298d4ee.jpg";